import { useCallback, useRef, useState } from 'react';
import { rmsApi } from '../../state/axios';

type Params = {
  onSuccess?(data?: any): void;
};

const useFetchDashboardList = ({ onSuccess }: Params) => {
  const [dashboardsListData, setDashboardsListData] = useState<any>(null);
  const [isDashboardListDataLoading, setIsDashboardListDataLoading] = useState(false);
  const [dashboardListDataFetchError, setDashboardListDataFetchError] = useState<any>(null);
  const hasFetchedRef = useRef(false);

  const fetchDashboardList = useCallback(async () => {
    if (hasFetchedRef.current) {
      return;
    }
    hasFetchedRef.current = true;
    setIsDashboardListDataLoading(true);
    setDashboardListDataFetchError(null);
    try {
      const response = await rmsApi.get('/api/v1/dar/dashboards');
      setDashboardsListData(response.data);
      onSuccess?.(response.data);
    } catch (error) {
      setDashboardListDataFetchError(error);
      hasFetchedRef.current = false;
    } finally {
      setIsDashboardListDataLoading(false);
    }
  }, [onSuccess]);

  return {
    dashboardsListData,
    dashboardListDataFetchError,
    isDashboardListDataLoading,
    fetchDashboardList
  };
};

export { useFetchDashboardList };
